export default "__VITE_ASSET__CVWqV4zO__"